// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export default class PackageCategory {
    public static readonly Books = [1469, 3038, 5161, 2640];

    public static readonly RepairYourself = 5438;
    public static readonly B2B = 5439;
    public static readonly Liquidation = 5201;
}
